module.exports = __webpack_public_path__ + "static/media/designPatent_30-0992965.754826b5.png";